var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-3"},[_c('legend',[_vm._v("Ошибки")]),_c('ul',{staticClass:"list-unstyled"},_vm._l((_vm.errors),function(error){return _c('li',{domProps:{"innerHTML":_vm._s(error)}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }